import { _legacyAddToast, useNotificationCenter, type NotifType } from '~/composables/useNotificationCenter'

export type { NotifType }
export interface Toast {
  id: number
  message: string
  icon?: string
  type?: NotifType
  duration?: number
}

/**
 * Compat : ancienne API toast. Les appels `addToast()` sont désormais traités comme du *feedback*
 * d'action (toast éphémère, masqué en mode « Ne pas déranger »). Pour des notifications
 * catégorisées (rare/routine, journal, coalescing), utiliser `useNotificationCenter().notify(...)`.
 */
export function useToast() {
  const { toasts, removeToast } = useNotificationCenter()

  function addToast(message: string, icon = '🔔', type: NotifType = 'info', duration = 4000) {
    _legacyAddToast(message, icon, type, duration)
  }

  function success(message: string, duration = 4000) {
    _legacyAddToast(message, '✅', 'success', duration)
  }
  function error(message: string, duration = 5000) {
    _legacyAddToast(message, '❌', 'error', duration)
  }
  function warning(message: string, duration = 4500) {
    _legacyAddToast(message, '⚠️', 'warning', duration)
  }
  function info(message: string, duration = 4000) {
    _legacyAddToast(message, 'ℹ️', 'info', duration)
  }

  return { toasts, addToast, removeToast, success, error, warning, info }
}
